'use strict';
module.exports = function buildDecoratedResultProcessor(resultProcessor, decorators) {
	return function (exportConfig) {
		return resultProcessor(exportConfig).then(function (result) {
			decorators.forEach(function (decorator) {
				decorator(result);
			});
			return result;
		});
	};
};
